// @flow
import React from 'react'
import moment from 'moment'
import OptimizedImage from 'components/atoms/OptimizedImage'
import { imageURLWithTransform } from 'frontend_core/dist/helpers/format'

export type PropTypes = {
  id: string,
  title: string,
  image: string,
  backgroundColor: string,
  validAt: Date,
  expiresAt: Date,
}

export default class PromotionItemCard extends React.Component<*> {
  props: PropTypes
  render() {
    const imageUrl = imageURLWithTransform(this.props.image, {
      width: 670,
      height: 400,
      crop: 'fill',
    })
    return (
      <div className="col-sm-12 col-md-4 campaign-box">
        <a href={`/promotions/${this.props.id}`}>
          <div className="campaign-linkbox is-hover">
            <div className="md-low-units md-campaign-units mdc-elevation--z2">
              <OptimizedImage src={imageUrl} alt={this.props.title} />
              <h3
                className="campaign-subtitle"
                style={{ backgroundColor: this.props.backgroundColor }}
              >
                <span className="campaign-subtitle__name">
                  {this.props.title}
                </span>
              </h3>
            </div>
          </div>
        </a>
        <p className="top-units__body-term">
          {moment(this.props.validAt).format(i18n.t('page.shared.dateFormat3'))}
          〜
          {moment(this.props.expiresAt).format(
            i18n.t('page.shared.dateFormat3'),
          )}
        </p>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/molecules/PromotionListItem/index.jsx